module.exports = function( THREE ){
	/**
	 * @author mrdoob / http://www.mrdoob.com
	 *
	 * Simple test shader
	 */

	THREE.BasicShader = {

		uniforms: {},

		vertexShader: [

			"void main() {",

				"gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

			"}"

		].join( "\n" ),

		fragmentShader: [

			"void main() {",

				"gl_FragColor = vec4( 1.0, 0.0, 0.0, 0.5 );",

			"}"

		].join( "\n" )

	};

}



//////////////////
// WEBPACK FOOTER
// ./~/three-js/addons/BasicShader.js
// module id = 402
// module chunks = 0